import React, { useEffect, useRef, useState, useMemo } from "react";
import styles from "./index.module.scss";
import FormContext from "./FormContext";
import qs from "qs";
import { useRouter } from "next/router";

export function FormItem(props) {
  const { children } = props;

  return (
    <div className={styles.formItem}>
      {props?.label && <label className={styles.label}>{props.label}</label>}
      {children}
    </div>
  );
}

export default function Form(props) {
  const { children } = props;
  const router = useRouter();
  const query = router.asPath.replace(router.pathname, "");
  const queryParams = qs.parse(query.replace("?", ""));
  const [state, setState] = useState(queryParams);
  const isFirstRender = useRef(true);

  let paramsTostring = {};
  for (const key in state) {
    if (state[key].length > 0) {
      paramsTostring = {
        ...paramsTostring,
        [key]: state[key].toString(),
      };
    } else {
      paramsTostring = {
        ...paramsTostring,
        [key]: state[key],
      };
    }
  }

  useEffect(() => {
    if (!isFirstRender.current) {
      props?.onChange(paramsTostring);
      router.push(
        {
          pathname: router.pathname,
          query: {
            ...router.query,
            ...paramsTostring,
          },
        },
        undefined,
        { shallow: true }
      );
    }
    isFirstRender.current = false;
  }, [state]);

  return (
    <FormContext.Provider value={[state, setState]}>
      <div className={styles.root}>{children}</div>
    </FormContext.Provider>
  );
}
